import React from 'react'
import {
  BooleanInput,
  Create,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin'
import validateExists from '../../validators/validateExists'
import validateTypebotPublicId from '../../validators/validateTypebotPublicId'

const CreateOrganization = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput
        source='name'
        validate={[required(), validateExists(props, 'name')]}
      />
      <TextInput source='logo_url' />
      <TextInput
        source='typebot_public_id'
        label='Chatbot (Typebot public ID)'
        helperText="Used by merchants that don't set their own"
        validate={validateTypebotPublicId}
      />
      <TextInput source='meta' />
      <BooleanInput source='enable_fleet_integration' />
      <BooleanInput source='allow_chargable_operations' />
    </SimpleForm>
  </Create>
)

export default CreateOrganization
